import React from "react"

import {
	Box,
	Button,
	FormControl,
	Grid,
	MenuItem,
	Select,
	SelectChangeEvent,
	Stack,
	Typography,
} from "@mui/material"

import {
	ErrorResponse, MatesSelect,
	MatesTextField,
	RestResponse,
	withUseFormHook
} from "@sinossi/mates-react-library"

import { t, Trans } from "@lingui/macro"
import {
	mdiAccessPoint,
	mdiCached,
	mdiContentSave,
	mdiDownload,
	mdiMagnify,
	mdiUpload,
} from "@mdi/js"
import Icon from "@mdi/react"
import { UseFormReturn } from "react-hook-form"

import {
	AssetType,
	BrandPriority,
	BrandPriorityResponse,
	ContractType, PositionType, SearchMatchRequest,
	SessionResponse, SwitchEnum
} from "models"

import {
	MatesComponent,
	MatesComponentState,
} from "components/mates-component"
import { DashboardServices } from "services/dashboard.services"
import { UseRouterParams } from "services/router"

import { Link } from "react-router-dom"
import { CreateResearchRequest } from "../../../../models/priorities"
import { AccountServices } from "../../../../services/account.services"
import { SbSnackbar } from "../../../commons/sb-snackbar"
import DashboardMapPrioritiesSearchSchema, { DashboardMapPrioritiesSearchForm } from "./form"
import { InfoMessageSearchForm } from "./info-message-search-form"
import { PageSectionTitle, RoutesData } from "components/commons"

interface DashboardMapSearchFormProps extends UseFormReturn, UseRouterParams {
	onBrandChange?: (brandId?: string) => void
	onSearch?: (priority: BrandPriority) => void
	sessionData: SessionResponse
	search: (request: SearchMatchRequest, id: string) => void
	clear: () => void
	openUploadDocument: () => void
	reloadPriorities: boolean
	selectedPriority: BrandPriority | null
	selectedBrand: string
}
interface DashboardMapSearchFormState extends MatesComponentState {
	currentBrand: string
	createResearch: boolean
	brandPriorities: BrandPriorityResponse | null
	selectedPriority: BrandPriority | null
	loading: boolean
	openInfoMessage: boolean
	snackbarData: {
		openNotification: boolean,
		severity: 'error' | 'info' | 'success' | 'warning',
		notificationMessage: string
	}
}
class DashboardMapSearchForm extends React.Component<DashboardMapSearchFormProps, DashboardMapSearchFormState> {
	private readonly matesComponent: MatesComponent<DashboardMapSearchFormProps, DashboardMapSearchFormState> = new MatesComponent(this)

	constructor(props: DashboardMapSearchFormProps) {
		super(props)
		this.state = {
			...this.matesComponent.setupState(),
			createResearch: false,
			currentBrand: this.props.selectedBrand,
			brandPriorities: null,
			selectedPriority: this.props.selectedPriority,
			loading: true,
			openInfoMessage: false,
			snackbarData: {
				openNotification: false,
				severity: "info",
				notificationMessage: ""
			}
		}
		//this.props.onBrandChange?.(this.props.selectedBrand)
		this.initializeForm()
	}

	componentDidMount() {
		//this.brandPriorities()
	}

	componentDidUpdate(prevProps: Readonly<DashboardMapSearchFormProps>, prevState: Readonly<DashboardMapSearchFormState>, snapshot?: any) {
		/* if (!prevProps.reloadPriorities && this.props.reloadPriorities) {
			this.brandPriorities()
		} */
	}

	private handleOpenNotification = (message: string, severity: 'error' | 'info' | 'success' | 'warning') => {
		this.setState(() => ({
			snackbarData: {
				openNotification: true,
				notificationMessage: message,
				severity: severity
			}
		}))
	};

	private handleCloseNotification = () => {
		this.setState(() => ({
			snackbarData: {
				...this.state.snackbarData,
				openNotification: false
			}
		}))
	};

	private initializeForm = () => {
		let searchData = DashboardMapPrioritiesSearchForm.fromServerResponse(this.state.selectedPriority, this.state.currentBrand)
		this.props.reset(searchData)
	}

	private onBrandChange = (event: SelectChangeEvent<string>, _: any): void => {
		const value: string = event.target.value
		this.setState(() => ({ currentBrand: value, loading: true }), () => this.props.onBrandChange?.(value))//, this.brandPriorities)
		//this.props.reset(new DashboardMapPrioritiesSearchForm())
	}

	/* private brandPriorities = () => {
		DashboardServices.getBrandPriorities(
			this.state.currentBrand,
			this.brandPriorityCallback,
			this.matesComponent.onException
		)
	} */

	private brandPriorityCallback = (response: RestResponse<BrandPriorityResponse, ErrorResponse>) => {
		if (response.hasError()) {
			this.matesComponent.onException(response)
			return
		}

		this.setState(() => ({
			brandPriorities: response.data,
			loading: false
		}))
	}
	private prioritySelection = (value: string): string => {
		if (!this.state.brandPriorities) {
			return value
		}

		let index: number | undefined
		let brandPriority = this.state.brandPriorities!.items
			.find((it, i) => {
				const found = it.id === value
				if (found) {
					index = i
				}

				return found
			})
		if (index === undefined) {
			return value
		}

		console.log(brandPriority)

		this.setState(() => ({
			selectedPriority: brandPriority!
		}), () => {
			let searchData = DashboardMapPrioritiesSearchForm.fromServerResponse(brandPriority, this.state.currentBrand)
			this.props.reset(searchData)

			const formValues = this.props.getValues()
			const request: SearchMatchRequest | null = DashboardMapPrioritiesSearchForm.getSearchRequest(formValues)

			if (request) {
				this.props.search(request, this.state.currentBrand)
			}
		})

		return value
	}

	private handleSave = (values: any) => {
		const hideMessage: boolean = localStorage.getItem("hideResearchMessage") === "true"
		if (!hideMessage) {
			this.setState(() => ({
				openInfoMessage: true
			}))
		}
		else {
			this.setState(() => ({
				createResearch: true
			}), () => {
				this.props.setValue("saveResearch", this.state.createResearch)
				this.props.handleSubmit(this.save)()
			})
		}
	}

	private closeInfoMessage = () => {
		this.setState(() => ({
			openInfoMessage: false
		}))
	}

	private confirmAndSave = (hide?: boolean) => {
		if (hide) {
			AccountServices.hideDashboardResearchMessage(this.props.sessionData.accountDetails.account.id, this.hideMessageCallback, this.matesComponent.onError)
		}
		this.setState(() => ({
			openInfoMessage: false,
			createResearch: true,
		}), () => {
			this.props.setValue("saveResearch", this.state.createResearch)
			this.props.handleSubmit(this.save)()
		})
	}

	private hideMessageCallback = (response: RestResponse<any, ErrorResponse>) => {
		if (response.hasError()) {
			this.matesComponent.onException(response)
			return
		}

		localStorage.setItem("hideResearchMessage", "true")
	}

	private save = () => {
		let request: CreateResearchRequest | null = DashboardMapPrioritiesSearchForm.getCreateRequest(this.props.getValues(), this.state.currentBrand)

		if (request) {
			DashboardServices.createBrandPriorities(
				request,
				this.createBrandPrioritiesCallback,
				this.matesComponent.onException)
		}
	}

	private createBrandPrioritiesCallback = (response: RestResponse<any, ErrorResponse>) => {
		if (response.hasError()) {
			this.matesComponent.onException(response)
			return
		}

		this.handleOpenNotification(
			t({ id: "dashboard-map-search-form.create-research.success", message: "La ricerca è stata creata con successo." }),
			"success"
		)

		this.search()
		//this.brandPriorities()
	}

	private search = (values?: any) => {
		const formValues = values !== undefined ? values : this.props.getValues()
		const request: SearchMatchRequest | null = DashboardMapPrioritiesSearchForm.getSearchRequest(formValues)

		if (request) {
			this.props.search(request, this.state.currentBrand)
		}
	}

	private clear = () => {
		this.props.reset(new DashboardMapPrioritiesSearchForm())

		this.props.clear()
	}

	render() {
		return (
			<>
				<PageSectionTitle title={RoutesData.PROPOSALS.title}/>
				<Grid container spacing={2} mt={1}>
					<Grid item xs={10} display="flex" justifyContent="flex-end" alignItems="center">
						<Typography fontWeight="600" fontSize="1.2em" textTransform="uppercase">Insegna corrente</Typography>
					</Grid>
					<Grid item xs={2}>
						<FormControl fullWidth>
							<Select
								defaultValue={this.state.currentBrand}
								onChange={this.onBrandChange}
								renderValue={(_): React.ReactNode => {
									let brand = this.props.sessionData.brands
										.find((brand) => brand.id === this.state.currentBrand)
									let data: string | undefined = brand?.logo

									return (
										<Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
											{data && <img src={data} className="brand-selector-image" alt="" />}
											<Typography sx={{ display: "inline" }} variant="body2">Cambia</Typography>
										</Box>
									)
								}}
							>
								{
									this.props.sessionData.brands.map((brand) => (
										<MenuItem key={brand.id} value={brand.id} sx={{ textTransform: "uppercase", }}>
											<img className="brand-selector-image" alt="" src={brand.logo} />
											{brand.name}
										</MenuItem>
									))
								}
							</Select>
						</FormControl>
					</Grid>

					<form style={{width: "100%"}}>
						<Grid container item spacing={2} sx={{ paddingLeft: 2, mt: 1 }}>
							<Grid item xs={3}>
								<MatesSelect
									name="savedSearch"
									label="Esplora aperture"
									variant="outlined"
									onChange={this.prioritySelection}
									formState={this.props.formState}
									control={this.props.control}
									trigger={this.props.trigger}
									disabled={this.state.loading}
								>
									{this.state.brandPriorities && this.state.brandPriorities.items
										.map((it: BrandPriority) => <option key={it.id} value={it.id}>{it.name}</option>)
									}
									{this.state.brandPriorities && this.state.brandPriorities.items.length === 0 &&
										<option disabled>Nessuna apertura salvata</option>
									}
								</MatesSelect>
							</Grid>
							<Grid item xs={9}>
								<Stack direction="row" spacing={1}>
									<Link to="/research">
										<Button
											size="medium"
											type="button"
											variant="contained"
											color="secondary"
											onClick={this.clear}
											endIcon={<Icon path={mdiAccessPoint} size={1} />}>Crea Apertura</Button>
									</Link>
									<Button
										size="medium"
										type="button"
										variant="contained"
										color="secondary"
										endIcon={<Icon path={mdiUpload} size={1} />}
										onClick={this.props.openUploadDocument}
									>
										Carica piano aperture (.csv)
									</Button>
									<Button
										size="medium"
										type="button"
										variant="contained"
										color="neutral"
										href={process.env.PUBLIC_URL + "/template_creazione_ricerca.csv"}
										target="_blank"
										rel="noreferrer"
										endIcon={<Icon path={mdiDownload} size={1} />}
									>
										<Trans id={"dashboard-map-search-form.opening-template-download"}>
											Scarica template piano aperture
										</Trans>
									</Button>
									<Button
										size="medium"
										type="button"
										variant="outlined"
										color="neutral"
										onClick={this.clear}
										endIcon={<Icon path={mdiCached} size={1} />}>Pulisci</Button>
								</Stack>
							</Grid>
							<Grid item xs={12} md={12} sx={{ mb: 2 }}></Grid> {/*sucks but fast*/}
							{false && <>
								<Grid item xs={12} md={12}>
									<MatesTextField
										name="name"
										label="Nome apertura"
										variant="outlined"
										control={this.props.control}
										trigger={this.props.trigger}
										formState={this.props.formState} />
								</Grid>
								<Grid item xs={12} md={3}>
									<MatesTextField
										name="region"
										label="Regione"
										variant="outlined"
										control={this.props.control}
										trigger={this.props.trigger}
										formState={this.props.formState} />
								</Grid>

								<Grid item xs={12} md={3}>
									<MatesTextField
										name="city"
										label="Città"
										variant="outlined"
										control={this.props.control}
										trigger={this.props.trigger}
										formState={this.props.formState} />
								</Grid>
								<Grid item xs={12} md={3}>
									<MatesTextField
										name="street"
										label="Via/Zona"
										variant="outlined"
										control={this.props.control}
										trigger={this.props.trigger}
										formState={this.props.formState} />
								</Grid>
								<Grid item xs={12} md={3}>
									<MatesSelect
										name="positionType"
										label={t({
											id: "dashboard-map-search-form.position",
											message: "Posizione",
										})}
										variant="outlined"
										control={this.props.control}
										formState={this.props.formState}
										trigger={this.props.trigger}
									>
										{
											Object.keys(PositionType).map((typeKey, index) =>
												<option value={typeKey} key={index}>
													<Trans id={`enums.asset-position.${typeKey}`}>
													</Trans>
												</option>
											)
										}
									</MatesSelect>
								</Grid>

								<Grid item xs={12} md={3}>
									<MatesSelect
										name="preferredContractTypes"
										label="Tipo di contratto"
										variant="outlined"
										formState={this.props.formState}
										control={this.props.control}
										trigger={this.props.trigger}>
										{Object.keys(ContractType).map(typeKey =>
											<option id={typeKey} value={typeKey}>
												<Trans id={`enums.contract-type.${typeKey}`}>
												</Trans>
											</option>
										)}
									</MatesSelect>
								</Grid>
								<Grid item xs={12} md={3}>
									<MatesTextField variant={"outlined"}
										label={t({
											id: "research.edit-research.max-price",
											message: `Prezzo massimo (€)`,
										}
										)}
										name="maxPrice"
										control={this.props.control}
										trigger={this.props.trigger}
										formState={this.props.formState}
									/>
								</Grid>
								<Grid item xs={6} md={3}>
									<MatesTextField
										name="minDim"
										label="Dim. minima (mq)"
										variant="outlined"
										control={this.props.control}
										trigger={this.props.trigger}
										formState={this.props.formState}
									/>
								</Grid>
								<Grid item xs={6} md={3}>
									<MatesTextField
										name="maxDim"
										label="Dim. massima (mq)"
										variant="outlined"
										control={this.props.control}
										trigger={this.props.trigger}
										formState={this.props.formState}
									/>
								</Grid>
								<Grid item xs={12} md={3}>
									<MatesSelect
										name="propertyType"
										label="Tipo"
										variant="outlined"
										formState={this.props.formState}
										control={this.props.control}
										trigger={this.props.trigger}>
										{Object.keys(AssetType).map(type =>
											<option id={type} value={type}>
												<Trans id={`enums.asset-types.${type}`}>
												</Trans>
											</option>
										)
										}
									</MatesSelect>
								</Grid>
								<Grid item xs={12} md={2}>
									<MatesSelect
										name="shopWindows"
										label={t({ id: "dashboard-map-search-form.shop-windows", message: "Vetrine" })}
										variant="outlined"
										formState={this.props.formState}
										control={this.props.control}
										trigger={this.props.trigger}>
										{
											Object.keys(SwitchEnum).map((typeKey, index) =>
												<option value={typeKey} key={index}>
													<Trans id={`enums.switch-enum.${typeKey}`}>
													</Trans>
												</option>
											)
										}
									</MatesSelect>
								</Grid>
								<Grid item xs={12} md={2}>
									<MatesSelect
										name="airConditioning"
										label={t({ id: "dashboard-map-search-form.air-conditioning", message: "Aria condizionata" })}
										variant="outlined"
										formState={this.props.formState}
										control={this.props.control}
										trigger={this.props.trigger}>
										{
											Object.keys(SwitchEnum).map((typeKey, index) =>
												<option value={typeKey} key={index}>
													<Trans id={`enums.switch-enum.${typeKey}`}>
													</Trans>
												</option>
											)
										}
									</MatesSelect>
								</Grid>
								<Grid item xs={12} md={2}>
									<MatesSelect
										name="parkingSlots"
										label={t({ id: "dashboard-map-search-form.parking-slots", message: "Parcheggi" })}
										variant="outlined"
										formState={this.props.formState}
										control={this.props.control}
										trigger={this.props.trigger}>
										{
											Object.keys(SwitchEnum).map((typeKey, index) =>
												<option value={typeKey} key={index}>
													<Trans id={`enums.switch-enum.${typeKey}`}>
													</Trans>
												</option>
											)
										}
									</MatesSelect>
								</Grid>
								<Grid item xs={6} md={2}>
									<MatesSelect
										name="singleLevel"
										label={t({ id: "research.edit-research.single-floor", message: "Singolo piano" })}
										variant="outlined"
										formState={this.props.formState}
										control={this.props.control}
										trigger={this.props.trigger}>
										{
											Object.keys(SwitchEnum).map((typeKey, index) =>
												<option value={typeKey} key={index}>
													<Trans id={`enums.switch-enum.${typeKey}`}>
													</Trans>
												</option>
											)
										}
									</MatesSelect>
								</Grid>
							</>}
							<Grid item xs={12} display="flex" justifyContent="center" sx={{ mb: 2 }}>
								<Stack direction="row" spacing={2}>
									{false && <Button
										type="button"
										variant="contained"
										color="primary"
										endIcon={<Icon path={mdiContentSave} size={1} />}
										onClick={this.handleSave}
									>
										Salva apertura
									</Button>}
									{false && <Button
										type="button"
										variant="contained"
										color="secondary"
										onClick={this.props.handleSubmit(this.search)}
										endIcon={<Icon path={mdiMagnify} size={1} />}>Trova compatibilità già elaborate</Button>}
								</Stack>
							</Grid>
						</Grid>
					</form>
				</Grid>
				{
					this.state.openInfoMessage &&
					<InfoMessageSearchForm onClose={this.closeInfoMessage} confirm={this.confirmAndSave} />
				}
				<SbSnackbar snackbarData={this.state.snackbarData} handleCloseNotification={this.handleCloseNotification} />
			</>
		)
	}
}

export default withUseFormHook<DashboardMapPrioritiesSearchForm>(
	DashboardMapSearchForm,
	DashboardMapPrioritiesSearchSchema,
	new DashboardMapPrioritiesSearchForm()
)
